import script from "./BaseResizer.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseResizer.vue?vue&type=script&lang=ts&setup=true"

import "./BaseResizer.vue?vue&type=style&index=0&id=3b1a328b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b1a328b"]])

export default __exports__